import Vue from "vue";
import router from "./router";
import store from "./store";
import Button from "ant-design-vue/lib/button";
import Input from "ant-design-vue/lib/input";
import message from "ant-design-vue/lib/message";
import notification from "ant-design-vue/lib/notification";
import Modal from "ant-design-vue/lib/modal";
import Spin from "ant-design-vue/lib/spin";
import Result from "ant-design-vue/lib/result";
import Empty from "ant-design-vue/lib/empty";
import PageHeader from "ant-design-vue/lib/page-header";
import Icon from "ant-design-vue/lib/icon";
import List from "ant-design-vue/lib/list";
import ListItem from "ant-design-vue/lib/list/Item";
import Tag from "ant-design-vue/lib/tag";
import Pagination from "ant-design-vue/lib/pagination";
import Skeleton from "ant-design-vue/lib/skeleton";
import Upload from "ant-design-vue/lib/upload";
import Divider from "ant-design-vue/lib/divider";
import InputSearch from "ant-design-vue/lib/input/Search";
import App from "./App.vue";
import emitter from "@/utils/mitt";
import "ant-design-vue/dist/antd.css";
import { get, post, put, del } from "./apis/index";
import "./assets/css/common.less";

Vue.component(Button.name, Button);
Vue.component(Input.name, Input);
Vue.component(Modal.name, Modal);
Vue.component(Spin.name, Spin);
Vue.component(Result.name, Result);
Vue.component(Empty.name, Empty);
Vue.component(PageHeader.name, PageHeader);
Vue.component(Icon.name, Icon);
Vue.component(List.name, List);
Vue.component(ListItem.name, ListItem);
Vue.component(Tag.name, Tag);
Vue.component(Pagination.name, Pagination);
Vue.component(Skeleton.name, Skeleton);
Vue.component(Upload.name, Upload);
Vue.component(Divider.name, Divider);
Vue.component(InputSearch.name, InputSearch);
Vue.config.productionTip = false;
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$put = put;
Vue.prototype.$delete = del;
Vue.prototype.$message = message;
Vue.prototype.$notifiy = notification;
Vue.prototype.$error = Modal.error;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
